import flowRight from 'lodash/flowRight';

var lowerCaseFirstLetter = function (sentence) {
    return sentence ? sentence[0].toLowerCase() + sentence.slice(1) : sentence;
};
var noEndPeriod = function (sentence) { return (sentence.endsWith('.') ? sentence.slice(0, -1) : sentence); };
var getBasePanelCode = function (code) { return (code || '').split('.')[0]; };
var cleanConceptPrefix = function (code) { return (code || '').replace('PR', ''); };
var getNumericBasePanelCode = function (code) {
    return flowRight([getBasePanelCode, cleanConceptPrefix])(code);
};

export { cleanConceptPrefix, getBasePanelCode, getNumericBasePanelCode, lowerCaseFirstLetter, noEndPeriod };
//# sourceMappingURL=stringFormatting.esm.js.map
